import { LoadingOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { map } from 'lodash-es';
import { useIntl } from 'react-intl';
import { generatePath, useHistory } from 'react-router';

import routes from '../../../app/routes';
import { FAIcon } from '../../../components/adapters/fontAwesomeAdapters';
import { useSelectsStyles } from '../../../components/forms/selects.styles';
import { useAccounts } from '../../../hooks/data/auth';
import { useAdminAccountSelectorStyles } from './AdminAccountSelector.styles';

export default function AdminAccountSelector({ accountNumber }) {
  const intl = useIntl();
  const history = useHistory();
  const { styles } = useSelectsStyles();
  const { styles: selectorStyles } = useAdminAccountSelectorStyles();

  const { customerAccounts, loading } = useAccounts();

  const options = map(customerAccounts, account => ({
    value: account.number,
    label: `${account.number} | ${account.name}`,
  }));

  const navigateTo = selected =>
    history.push(
      selected
        ? generatePath(routes.admin.accountDetail.root, {
            accountNumber: selected,
          })
        : routes.admin.accountManagement
    );

  return (
    <Select
      className={selectorStyles.selector}
      showSearch
      allowClear
      optionFilterProp="label"
      value={accountNumber || undefined}
      placeholder={intl.formatMessage({
        id: 'admin.accountManagement.selectAccount',
      })}
      suffixIcon={
        loading ? (
          <LoadingOutlined spin className={styles.selectLoading} />
        ) : (
          <FAIcon icon="caret-down" className={styles.selectArrow} />
        )
      }
      onChange={navigateTo}
      options={options}
    />
  );
}
